import React, { useEffect, useMemo, useState } from "react";
import HeaderCompo from "../../../component/Header";
import { Button, Input, message, Modal, Space, Table, Tooltip } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  SearchOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { supplierData } from "../../../data";
import UpdateSupplier from "../../../components/supplierModal/SupplierModal";
import { axiosInstance } from "../../../utils/axiosInterceptor";
import { BE_HOST } from "../../../config/config";
import { render } from "@testing-library/react";
import SupplierViewModal from "../../../components/supplierModal/SupplierViewModal";
import debounce from "lodash/debounce";
const Supplier = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setIsLoading] = useState(false);
  const [isPopUpVisible, setPopupVisible] = useState(false);
  const [selectedAccount, setSelectedAccounts] = useState([]);
  const [selectedsupplier, setSelectedSupplier] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [viewPopUp, setViewPopUp] = useState(false);

  const validateName = (inp) => {
    if (inp === "" || inp === undefined || inp === null || inp === "null") {
      return "-";
    }
    return inp;
  };

  const handleEdit = async(record,flag) => {
    try {
      const response = await axiosInstance.get(`api/suppliers/${record?.id}`);
      setSelectedSupplier(response?.data?.data);
      if(flag === true){
        setViewPopUp(true);
      }else{
        setPopupVisible(true);
      }
    } catch (error) {
      message.error("Something went wrong")
    }finally{

    }
  };
  const handleView = (record) => {
    setSelectedSupplier(record);
  };
  const columns = [
    {
      title: "Supplier Name",
      dataIndex: "wholesaler_name",
      key: "wholesaler_name",
      render: (text) => validateName(text),
      width: "23%",
      // sorter:true,
      // sorter: (a, b) => a.wholesaler_name - b.wholesaler_name,
    },
    {
      title: "Business Name",
      dataIndex: "business_name",
      key: "business_name",
      render: (text) => validateName(text),
      // sorter: (a, b) => a.business_name - b.business_name,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => validateName(text),
      // sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (text) => validateName(text),
      // sorter: (a, b) => (a.phone || "").localeCompare(b.phone || ""),
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (flag) =>
        flag === true ? "True" : flag === false ? "False" : "-",
      // sorter: (a, b) => (a.is_active || "").localeCompare(b.is_active || ""),
    },
    {
      title: "Actions",
      key: "actions",
      width: "10%",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Supplier">
            <Button
              type="text"
              icon={<EyeOutlined />}
              onClick={() => handleEdit(record,true)}
            />
          </Tooltip>
          <Tooltip title="Update Supplier">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Edit Supplier">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record.id)}
              danger
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  const handleDelete = async (id) => {
    Modal.confirm({
      title: "Delete Supplier",
      content: "Are you sure you want to delete this Supplier?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      okButtonProps: {
        style: {
          float: "left",
        },
      },
      cancelButtonProps: {
        style: {
          float: "right",
        },
      },
      onOk: async () => {
        try {
          const response = await axiosInstance.delete(`api/suppliers/${id}`);


          message.success("Supplier deleted successfully");

          getSupplier(); 
        } catch (error) {
          console.log(error);

          message.error(
            error?.response?.data?.message || "Failed to delete supplier",
          );
        }
      },
    });
  };
  const handleAdd = () => {
    setSelectedSupplier(null);
    setPopupVisible(true);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchText(value);

        setPagination((prev) => ({
          ...prev,
          current: 1,
        }));
      }, 500),
    [],
  );
  const getSupplier = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `${BE_HOST}/api/suppliers?page=${pagination.current}&take=${pagination.pageSize}&search=${searchText}`,
      );
      setSuppliers(response?.data?.data?.data);
      const pages = response?.data?.data;
      setPagination((prev) => ({
        ...prev,
        total: pages?.total || 0,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearch = (val) => {
    setSearchText(val);
  };

  useEffect(() => {
    getSupplier();
  }, [pagination.current, pagination.pageSize, searchText]);
  return (
    <div>
      <HeaderCompo initialColor={"#000833"} />
      <div className="p-4">
        <div
          className="flex md:items-center md:justify-between  flex-col md:flex-row gap-4 mb-4 px-4 pt-4"
          style={{ padding: "16px 16px 0 16px" }}
        >
          <h1 className="text-2xl font-bold">Supplier Management</h1>
          <div className="flex sm:flex-row gap-2 w-full md:w-auto">
            <Input
              placeholder="Search by Supplier name / Number..."
              prefix={<SearchOutlined />}
              onChange={(e) => debouncedSearch(e.target.value)}
              className="w-[90%] sm:w-[250px] "
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                // width: 250,
                height: "40px",
              }}
              allowClear
            />

            <Tooltip title="Add New Supplier">
              <Button
                type="primary"
                icon={<UserAddOutlined />}
                onClick={handleAdd}
                style={{ height: "40px" }}
              />
            </Tooltip>
          </div>
        </div>

        <Table
          columns={columns}
          dataSource={suppliers}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            showTotal: (total) =>
              `Total ${total < 10 ? suppliers?.length : total} accounts`,
          }}
          onChange={(paginationData) => {
            setPagination((prev) => ({
              ...prev,
              current: paginationData.current,
              pageSize: paginationData.pageSize,
            }));
          }}
          loading={loading}
          scroll={{ x: 1000 }}
          className="custom-table user-tbl"
        />
        <UpdateSupplier
          popupWithScrollViewVisible={isPopUpVisible}
          hide={() => setPopupVisible(false)}
          data={selectedsupplier}
          isNewRecord={!selectedsupplier}
          getSupplier={getSupplier}
        />
        <SupplierViewModal
          popupWithScrollViewVisible={viewPopUp}
          hide={() => setViewPopUp(false)}
          data={selectedsupplier}
          isNewRecord={!selectedsupplier}
          getSupplier={getSupplier}
        />
      </div>
    </div>
  );
};

export default Supplier;
